import { render, staticRenderFns } from "./BordereauxTab.vue?vue&type=template&id=c271e97c&"
import script from "./BordereauxTab.vue?vue&type=script&lang=js&"
export * from "./BordereauxTab.vue?vue&type=script&lang=js&"
import style0 from "./BordereauxTab.vue?vue&type=style&index=0&id=c271e97c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports